import React, { useState } from "react";
import InsightsSideBar from "../../../../../InsightsSideBar";
import { useReports } from "./hooks/useReports";
import { useDownloadExcel } from "./hooks/useDownloadExcel";
import { ReportLayout } from "../../../../../components/ReportLayout/ReportLayout";
import { Header } from "./components/Header/Header";
import { Table } from "./components/Table/Table";
import { AlertBox } from "../../../../../../../shared/AlertBox/AlertBox";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { Box } from "../../../../../../../shared/Box/Box";

export function ExpiringLiabilityReport() {
  const { tBi } = useAppTranslation.BusinessInsights();

  // filter state for the report: default to 30 days
  const [filter, setFilter] = useState({ type: "days", days: 30 });

  const { reports } = useReports({ filter });
  const downloadExcel = useDownloadExcel({ filter });

  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper">
        <InsightsSideBar />
        <div className="memberWalletOuter business-section">
          <ReportLayout>
            <Header
              total={reports.total}
              downloadExcel={downloadExcel}
              isReportsLoading={reports.isLoading}
              isDownloadExcelDisabled={!reports.isWalletExpirationConfigured}
              filter={filter}
              onFilterChange={setFilter}
            />
            {reports.isAccountLoading ? (
              <Box>
                <Skeleton count={15} height={39.06} borderRadius="0px" />
              </Box>
            ) : (
              <>
                {reports.isWalletExpirationConfigured ? (
                  <Table reports={reports} />
                ) : (
                  <AlertBox>
                    {tBi("liabilityReports.expiring.disabled")}
                  </AlertBox>
                )}
              </>
            )}
          </ReportLayout>
        </div>
      </div>
    </div>
  );
}
